import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { CustomARREnrollmentScreenComponent } from './custom-arr-enrollment-screen.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [CustomARREnrollmentScreenComponent],
    imports: [
        CommonModule,
        RouterModule,
        I18nModule,
        FormsModule,
        ReactiveFormsModule,
        ConfigModule.withConfig({
            cmsComponents: {
                SeqirusAutoEnrollmentScreenComponent: {
                    component: CustomARREnrollmentScreenComponent,
                },
            }
        } as CmsConfig)

    ],
    exports: []
})
export class CustomARREnrollmentScreenModule {}